import type { ReportResult, ReportType } from "@verity/api-client";

export type InstitutionReportEmailData = {
	institutionId: number;
	month: number;
	year: number;
	adminEmails: string[];
	topMetrics: TopMetric[];
	title: string;
	summary: string;
};

export type TopMetric =
	| {
			type: "increase";
			key: "totalFlags" | "totalAttempts" | "totalAssessments" | "totalHours" | "totalLiveHours" | "totalTestTakers";
			currentValue: string;
			previousValue: string;
			percentChange: string;
			texts: [string, string, string];
			imageUrl: string;
	  }
	| {
			type: "increase-am";
			key: "totalFlags" | "totalAttempts" | "totalAssessments" | "totalHours" | "totalLiveHours" | "totalTestTakers";
			currentValue: string;
			previousValue: string;
			percentChange: string;
			texts: [string, string, string];
			imageUrl: string;
	  }
	| {
			type: "decrease-am";
			key: "totalFlags" | "totalAttempts" | "totalAssessments" | "totalHours" | "totalLiveHours" | "totalTestTakers";
			currentValue: string;
			previousValue: string;
			percentChange: string;
			texts: [string, string, string];
			imageUrl: string;
	  }
	| {
			type: "absolute";
			key: "totalFlags" | "totalAttempts" | "totalAssessments" | "totalHours" | "totalLiveHours" | "totalTestTakers";
			currentValue: string;
			previousValue: string;
			percentChange: string;
			texts: [string, string, string];
	  }
	| {
			type: "absolute-am";
			key: "totalFlags" | "totalAttempts" | "totalAssessments" | "totalHours" | "totalLiveHours" | "totalTestTakers";
			currentValue: string;
			previousValue: string;
			percentChange: string;
			texts: [string, string, string];
	  };

export type ExportReportInfo =
	| {
			reportType: Extract<ReportType, "institution" | "course">;
			institutionCourseReportInfo: {
				id?: number; // Course Report may have id undefined
				startDate: Date;
				endDate: Date;
				verityFetch: typeof fetch;
				institutionInfo?: { subAccountName?: string; subAccountId?: number };
				courseInfo?: { courseName: string };
			};
			assessmentReportInfo?: never;
	  }
	| {
			reportType: Extract<ReportType, "assessment">;
			assessmentReportInfo: ReportResult & { assessmentName: string };
			institutionCourseReportInfo?: never;
	  };

export type ExportReportEmail = {
	toEmail: string;
	reportType: ReportType;
	filters?: string;
	fileName: string;
	fileContent: string; // base64 encoded
	contentType: string;
};

export const FileExtensionMap: Record<FormatType, string> = {
	json: "json",
	excel: "xlsx",
	csv: "zip", // zip csv file
};

export type ExportResult = { success: true } | { success: false; error: string };

export type SubAccountNode = {
	id: number;
	accountName: string;
	lmsAccountId: string;
	parentLmsAccountId: string | null;
	rootLmsAccountId: string | null;
	children: SubAccountNode[];
};

export type ExportType = "download" | "email";
export type FormatType = "json" | "csv" | "excel";

export type ExportReportRadioGroupProps = {
	onChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
	selectedValue: string;
	type: "export" | "format";
};

export type YearSelection = number | "current";

export interface CenterTextPluginOptions {
	display: boolean;
	semiCircle?: boolean;
	smallText?: boolean;
	text: string;
}
